import { isEmpty, isNil } from "ramda";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { useGoogleOptimizeActions } from "store/GoogleOptimizeSlice";
import { jjLogger } from "utils/logUtils";
import { GO_TEST_NAMES } from "enums";

const useGoogleOptimize = (isNeccesaryListen = false) => {
  const goConnections = useRef(0);
  const GO_CONNECTION_TRIES = 10;
  const { setLoading, updateTestValues } = useGoogleOptimizeActions();
  const testValues = useSelector((state) => state.GoogleOptimizeSlice.testValues);
  const loading = useSelector((state) => (isNeccesaryListen ? state.GoogleOptimizeSlice.loading : true));

  const { location } = window;
  const queryParams = new URLSearchParams(location.search);

  const storeTestValue = (goTests) => {
    jjLogger.logDebug(`useGoogleOptimize.js: storeTestValue - goTests: ${JSON.stringify(goTests)}`);
    const urlTests = Object.values(GO_TEST_NAMES).reduce((acc, parameter) => {
      let newTest = { ...acc };
      if (queryParams.has(parameter)) {
        newTest = { ...acc, [parameter]: queryParams.get(parameter) };
      }
      return newTest;
    }, {});

    jjLogger.logDebug(`useGoogleOptimize.js: storeTestValue - urlTest: ${JSON.stringify(urlTests)}`);

    updateTestValues({ ...goTests, ...urlTests });
  };

  useEffect(() => {
    jjLogger.logDebug(`useGoogleOptimize.js: useEffect testValueChanged - loading: ${JSON.stringify(loading)}`);
    jjLogger.logDebug(`useGoogleOptimize.js: useEffect testValueChanged - testValues: ${JSON.stringify(testValues)}`);
  }, [testValues]);

  const loadTest = () => {
    const goInterval = setInterval(() => {
      if (!isNil(window.GO) && !isEmpty(window.GO)) {
        jjLogger.logDebug(`useGoogleOptimize.js: loadTest - The GO experiments were loaded them success`);
        storeTestValue(window.GO);
        setLoading(false);
        clearInterval(goInterval);
        return;
      }
      if (goConnections.current >= GO_CONNECTION_TRIES) {
        jjLogger.logDebug(
          `useGoogleOptimize.js: loadTest - Maximum of attempts to connect to GO executed, the GO experiments didn't be loaded`,
        );
        clearInterval(goInterval);
        setLoading(false);
        return;
      }
      goConnections.current += 1;
      jjLogger.logDebug(
        `useGoogleOptimize.js: loadTest - goConnections: ${goConnections.current} of ${GO_CONNECTION_TRIES}`,
      );
    }, 450);
  };

  return {
    loading,
    loadTest,
    testValues,
  };
};

export default useGoogleOptimize;
